import React, { useState } from "react";

import styled from "styled-components";

const SIDEBAR_MIN_WIDTH = 260;
const SIDEBAR_MAX_WIDTH = 800;
const SIDEBAR_AUTOFOLD_WIDTH = 220;

const MainRow = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    height: 100%;
    width: 100%;
    position: relative;
`;

const MainSection = styled.main`
    flex: 1;
    height: 100%;
    position: relative;
    overflow: hidden;
    min-width: 0;
`;

const ResizeHandle = styled.div`
    width: 3px;
    flex-shrink: 0;
    background-color: var(--color-Grey3);
    opacity: 0.5;
    cursor: ew-resize;
    transition:
        background-color 160ms ease-in,
        opacity 160ms ease-in;

    &:hover {
        background-color: var(--color-Key);
        opacity: 1;
    }
`;

const Sidebar = styled.aside`
    position: relative;
    width: ${(props) => (props.$isFold ? "0px" : props.$width + "px")};
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-shrink: 0;
    transition: ${({ $isResizing }) => ($isResizing ? "none" : "width 180ms ease-in-out")};
`;

function ManuscriptEditorPageLayout({
    main,
    sidebar = null,
    sidebarRail = null,
    sidebarWidth,
    onSidebarWidthChange,
    isSidebarCollapsed,
    onSidebarCollapsedChange,
}) {
    const [isResizing, setIsResizing] = useState(false);

    const startSidebarResizing = (event) => {
        if (isSidebarCollapsed) return;
        event.preventDefault();
        const startX = event.clientX;
        const startWidth = sidebarWidth;
        let latestWidth = sidebarWidth;
        setIsResizing(true);
        document.body.style.userSelect = "none";
        document.body.style.cursor = "col-resize";

        const handleMouseMove = (e) => {
            const nextWidth = Math.max(SIDEBAR_MIN_WIDTH, Math.min(SIDEBAR_MAX_WIDTH, startWidth + startX - e.clientX));
            latestWidth = nextWidth;
            onSidebarWidthChange(nextWidth);
        };

        const handleMouseUp = () => {
            setIsResizing(false);
            if (latestWidth <= SIDEBAR_AUTOFOLD_WIDTH) {
                onSidebarCollapsedChange(true);
            }
            document.body.style.userSelect = "";
            document.body.style.cursor = "";
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);
    };

    return (
        <MainRow>
            <MainSection>{main}</MainSection>
            {sidebar && !isSidebarCollapsed && <ResizeHandle onMouseDown={startSidebarResizing} />}
            {sidebar && (
                <Sidebar $width={sidebarWidth} $isResizing={isResizing} $isFold={isSidebarCollapsed}>
                    {sidebar}
                </Sidebar>
            )}
            {sidebarRail}
        </MainRow>
    );
}

export default ManuscriptEditorPageLayout;
